function createImperativePromise(promiseArg) {
  var _resolve2 = null;
  var _reject2 = null;
  var wrappedPromise = new Promise(function (_resolve, _reject) {
    _resolve2 = _resolve;
    _reject2 = _reject;
  });
  promiseArg && promiseArg.then(function (val) {
    _resolve2 && _resolve2(val);
  }, function (error) {
    _reject2 && _reject2(error);
  });
  return {
    promise: wrappedPromise,
    resolve: function resolve(value) {
      _resolve2 && _resolve2(value);
    },
    reject: function reject(reason) {
      _reject2 && _reject2(reason);
    },
    cancel: function cancel() {
      _resolve2 = null;
      _reject2 = null;
    }
  };
}
export { createImperativePromise };